import classNames from "classnames";
import { motion } from "framer-motion";
import Head from "next/head";
import Image from "../../component/ImgComponent";
import Link from "next/link";
import React, { useState } from "react";
import ContainerFluid from "../../component/ContainerFluid";
import Header from "../../component/Header/Header";
import TopBanner from "../../component/Home/TopBanner";
import TopBannerButton from "../../component/Home/TopBannerButton";
import styles from "./Survey.module.scss";
import surveyLang from "../../i18n/survey";
import { getQuestionCategories } from "actions/requests";

const Survey = ({ locale, categories }) => {
  const [categoryId, setCategoryId] = useState("");

  const renderOptions = (data = [], label) => {
    return data.map((d) => {
      return (
        <option value={d.id * 1} key={d.key + "" || d.id + ""}>
          {label ? d[label] : d.label}
        </option>
      );
    });
  };

  const selectCategories = (e) => {
    setCategoryId(e.target.value);
  };

  return (
    <>
      <Head>
        <title>Survey overview</title>
        <meta property="og:title" content="Survey overview"></meta>
        <meta property="og:description" content="Survey overview"></meta>
      </Head>
      <ContainerFluid className={classNames("survey-detail")}>
        <Header />
        <ContainerFluid>
          <TopBanner
            customHeight
            contentClass="mt-0"
            mode="fill"
            title={surveyLang.title[locale]}
            description={
              <>
                <p>{surveyLang.paragraph1[locale]}</p>
                <p>{surveyLang.paragraph2[locale]}</p>
              </>
            }
            actions={(mode) => (
              <>
                <div className="row">
                  <div className="col-9 col-md-9 col-lg-6 mt-3">
                    <select
                      className={classNames(
                        styles.select_categories,
                        "form-control"
                      )}
                      onChange={selectCategories}
                    >
                      <option value="">
                        {surveyLang.select_categories[locale]}
                      </option>
                      {renderOptions(categories?.data)}
                    </select>
                  </div>
                </div>
                {categoryId && (
                  <Link
                    href={{
                      pathname: "/survey/starting",
                      query: { category_ids: [categoryId] },
                    }}
                  >
                    <a>
                      <TopBannerButton
                        className={classNames(
                          "mt-3 mb-3",
                          mode === "fill" && "border-white"
                        )}
                        title={surveyLang.start_button[locale]}
                      />
                    </a>
                  </Link>
                )}
              </>
            )}
          >
            <div
              className={classNames(
                styles.rightPanel,
                "col-12 col-md-6 text-center"
              )}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0,
                  translateX: 200,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                  translateX: 0,
                }}
                transition={{ duration: 0.5 }}
              >
                <Image
                  width={550}
                  height={240}
                  objectFit="contain"
                  src="/static/survey.png"
                  alt="survey banner"
                />
              </motion.div>
            </div>
          </TopBanner>
          <div
            className={classNames(styles.survey_overview_wrapper, "container")}
          >
            <div className="row">
              <div className="col-12 col-lg-3">
                <h3 className="text-dark-blue md-text-size">
                  {surveyLang.overview[locale]}
                </h3>
              </div>
              <div className="col-12 col-lg-9">
                <p>{surveyLang.overview_paragraph1[locale]}</p>
                <p>{surveyLang.overview_paragraph2[locale]}</p>
                <p>{surveyLang.overview_paragraph3[locale]}</p>
              </div>
            </div>
          </div>
        </ContainerFluid>
      </ContainerFluid>
    </>
  );
};

export const getServerSideProps = async (params) => {
  const categories = await getQuestionCategories({
    lang_ids: `[${params.locale === "vi" ? 1 : 2}]`,
    status: 1,
    is_question: true,
  });
  return {
    props: {
      categories: categories.data,
    },
  };
};

export default Survey;
